import React, { FunctionComponent } from "react";
import { Content } from "@iventis/translations/content/typed-content";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import EnumToRadioButtons from "@iventis/components/src/enum-to-radio-buttons";

export const ShareScheduleOptions: FunctionComponent<{
    onSelect: (option: ScheduleShareOption) => void;
    selected: ScheduleShareOption;
}> = ({ onSelect, selected }) => {
    const translate = useIventisTranslate();
    return (
        <>
            <p>{translate(Content.schedule3.shareOrExport.pickOption)}</p>
            <EnumToRadioButtons<ScheduleShareOption>
                radioButtons={[
                    {
                        name: translate(Content.schedule3.shareOrExport.shareLinkOptionTitle),
                        description: translate(Content.schedule3.shareOrExport.shareLinkOptionDescription),
                        type: ScheduleShareOption.LINK,
                    },
                    {
                        name: translate(Content.schedule3.shareOrExport.exportOptionTitle),
                        description: translate(Content.schedule3.shareOrExport.exportOptionDescription),
                        type: ScheduleShareOption.EXPORT,
                    },
                ]}
                value={selected}
                onChange={onSelect}
            />
        </>
    );
};

export enum ScheduleShareOption {
    LINK,
    EXPORT,
}
